import React, { useEffect, useState } from 'react';
import './styles/GenerateKeys.css';
import { supabase } from './supabaseClient';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import logo from './assets/logo.png';

const GenerateKeys = () => {
  const [bots, setBots] = useState([]);
  const [selectedBot, setSelectedBot] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [duration, setDuration] = useState('30d');
  const [generatedKeys, setGeneratedKeys] = useState([]);

  useEffect(() => {
    const fetchBots = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const user = session?.user;
      if (!user) return;

      const { data, error } = await supabase
        .from('robot_licenses')
        .select('id, ea_name, pairs, image_name, file_name')
        .eq('user_id', user.id)
        .is('key', null) // ✅ Get only bots, not license keys
        .not('ea_name', 'is', null); // ✅ Ensure valid EA

      if (error) {
        console.error('Error fetching bots:', error.message);
      } else {
        setBots(data);
      }
    };

    fetchBots();
  }, []);

  const generateKey = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const getSegment = (len) =>
      [...Array(len)].map(() => chars[Math.floor(Math.random() * chars.length)]).join('');
    return `${getSegment(4)}-${getSegment(4)}-${getSegment(4)}-${getSegment(4)}`;
  };

  const handleGenerate = async () => {
    if (!selectedBot || !displayName || quantity < 1) {
      alert('Please fill in all fields.');
      return;
    }

    const {
      data: { session },
    } = await supabase.auth.getSession();
    const user = session?.user;
    if (!user) return;

    const bot = bots.find((b) => b.id === selectedBot);
    if (!bot) {
      alert('Bot not found.');
      return;
    }

    const now = new Date();
    const keysToInsert = Array.from({ length: quantity }).map(() => {
      const key = generateKey();
      const expires_at =
        duration === 'lifetime'
          ? null
          : new Date(now.getTime() + {
              '5d': 5,
              '30d': 30,
              '1y': 365
            }[duration] * 24 * 60 * 60 * 1000).toISOString();

      return {
        key,
        display_name: displayName,
        ea_name: bot.ea_name,
        created_at: now.toISOString(),
        used: false,
        expires_at,
        user_id: user.id,
        pairs: bot.pairs, // ✅ Required
        image_name: bot.image_name, // ✅ Required
        file_name: bot.file_name // ✅ Required
      };
    });

    const { error } = await supabase
      .from('robot_licenses')
      .insert(keysToInsert);

    if (error) {
      console.error('❌ Insert error:', error);
      alert(`Failed to generate keys:\n${error.message}`);
    } else {
      setGeneratedKeys(keysToInsert.map((k) => k.key));
      alert('✅ Keys generated successfully!');
    }
  };

  return (
    <div className="generate-keys-container">
      <div className="generate-keys-header">
        <Link to="/dashboard" className="back-arrow"><FaArrowLeft /></Link>
        <img src={logo} alt="App Logo" className="top-logo" />
      </div>

      <h2>Generate License Keys</h2>

      <div className="form-group">
        <label>Select EA:</label>
        <select value={selectedBot} onChange={(e) => setSelectedBot(e.target.value)}>
          <option value="">-- Select EA --</option>
          {bots.map((bot) => (
            <option key={bot.id} value={bot.id}>{bot.ea_name}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Display Name:</label>
        <input
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Number of Keys:</label>
        <input
          type="number"
          min="1"
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value))}
        />
      </div>

      <div className="form-group">
        <label>License Duration:</label>
        <select value={duration} onChange={(e) => setDuration(e.target.value)}>
          <option value="5d">5 Days</option>
          <option value="30d">30 Days</option>
          <option value="1y">1 Year</option>
          <option value="lifetime">Lifetime</option>
        </select>
      </div>

      <button onClick={handleGenerate}>Generate Keys</button>

      {generatedKeys.length > 0 && (
        <div className="generated-keys">
          <h3>Generated Keys</h3>
          <ul>
            {generatedKeys.map((key, idx) => (
              <li key={idx}>{key}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default GenerateKeys;